var $8uLkp$swchelperscjs_async_iteratorcjs = require("@swc/helpers/cjs/_async_iterator.cjs");
var $8uLkp$swchelperscjs_async_to_generatorcjs = require("@swc/helpers/cjs/_async_to_generator.cjs");
var $8uLkp$swchelperscjs_await_async_generatorcjs = require("@swc/helpers/cjs/_await_async_generator.cjs");
var $8uLkp$swchelperscjs_call_supercjs = require("@swc/helpers/cjs/_call_super.cjs");
var $8uLkp$swchelperscjs_class_call_checkcjs = require("@swc/helpers/cjs/_class_call_check.cjs");
var $8uLkp$swchelperscjs_create_classcjs = require("@swc/helpers/cjs/_create_class.cjs");
var $8uLkp$swchelperscjs_inheritscjs = require("@swc/helpers/cjs/_inherits.cjs");
var $8uLkp$swchelperscjs_object_without_propertiescjs = require("@swc/helpers/cjs/_object_without_properties.cjs");
var $8uLkp$swchelperscjs_sliced_to_arraycjs = require("@swc/helpers/cjs/_sliced_to_array.cjs");
var $8uLkp$swchelperscjs_type_ofcjs = require("@swc/helpers/cjs/_type_of.cjs");
var $8uLkp$swchelperscjs_wrap_async_generatorcjs = require("@swc/helpers/cjs/_wrap_async_generator.cjs");
var $8uLkp$swchelperscjs_ts_generatorcjs = require("@swc/helpers/cjs/_ts_generator.cjs");
var $8uLkp$webstreamspolyfill = require("web-streams-polyfill");
var $8uLkp$webutility = require("web-utility");
var $8uLkp$swchelperscjs_object_spreadcjs = require("@swc/helpers/cjs/_object_spread.cjs");
var $8uLkp$swchelperscjs_object_spread_propscjs = require("@swc/helpers/cjs/_object_spread_props.cjs");
var $8uLkp$swchelperscjs_to_consumable_arraycjs = require("@swc/helpers/cjs/_to_consumable_array.cjs");
var $8uLkp$swchelperscjs_wrap_native_supercjs = require("@swc/helpers/cjs/_wrap_native_super.cjs");
var $8uLkp$swchelperscjs_assert_this_initializedcjs = require("@swc/helpers/cjs/_assert_this_initialized.cjs");
var $8uLkp$swchelperscjs_getcjs = require("@swc/helpers/cjs/_get.cjs");
var $8uLkp$swchelperscjs_get_prototype_ofcjs = require("@swc/helpers/cjs/_get_prototype_of.cjs");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4147"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4147"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fxgA4", function(module, exports) {

$parcel$export(module.exports, "FileMethod", function () { return FileMethod; });
$parcel$export(module.exports, "defaultDataRuntime", function () { return defaultDataRuntime; });
$parcel$export(module.exports, "DataToolkit", function () { return DataToolkit; });
$parcel$export(module.exports, "polyfillProgressEvent", function () { return polyfillProgressEvent; });
$parcel$export(module.exports, "parseDocument", function () { return parseDocument; });
$parcel$export(module.exports, "makeFormData", function () { return makeFormData; });
$parcel$export(module.exports, "serializeNode", function () { return serializeNode; });
$parcel$export(module.exports, "serialize", function () { return serialize; });
$parcel$export(module.exports, "takeBytes", function () { return takeBytes; });
$parcel$export(module.exports, "readBytes", function () { return readBytes; });
$parcel$export(module.exports, "makeStream", function () { return makeStream; });
$parcel$export(module.exports, "streamFromProgress", function () { return streamFromProgress; });
$parcel$export(module.exports, "emitStreamProgress", function () { return emitStreamProgress; });
$parcel$export(module.exports, "readAs", function () { return readAs; });
$parcel$export(module.exports, "encodeBase64", function () { return encodeBase64; });














var FileMethod = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
var DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
var defaultDataRuntime = {
    DOMParser: globalThis.DOMParser,
    Node: globalThis.Node,
    Document: globalThis.Document,
    HTMLElement: globalThis.HTMLElement,
    SVGElement: globalThis.SVGElement,
    FormData: globalThis.FormData,
    URLSearchParams: globalThis.URLSearchParams,
    Blob: globalThis.Blob,
    FileReader: globalThis.FileReader,
    Event: globalThis.Event,
    ProgressEvent: globalThis.ProgressEvent,
    ReadableStream: (0, $8uLkp$webstreamspolyfill.ReadableStream)
};
var DataToolkit = /*#__PURE__*/ function() {
    "use strict";
    function DataToolkit() {
        var _this = this;
        var runtime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultDataRuntime;
        var _this1 = this;
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, DataToolkit);
        var _this2 = this;
        var _globalThis;
        this.runtime = runtime;
        this.polyfillProgressEvent = function() {
            return (_globalThis = globalThis).ProgressEvent || (_globalThis.ProgressEvent = /*#__PURE__*/ function(_this_runtime_Event) {
                (0, $8uLkp$swchelperscjs_inheritscjs._)(ProgressEvent, _this_runtime_Event);
                function ProgressEvent(type) {
                    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, ProgressEvent);
                    var _this;
                    var lengthComputable = _param.lengthComputable, total = _param.total, loaded = _param.loaded, meta = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param, [
                        "lengthComputable",
                        "total",
                        "loaded"
                    ]);
                    _this = (0, $8uLkp$swchelperscjs_call_supercjs._)(this, ProgressEvent, [
                        type,
                        meta
                    ]);
                    _this.lengthComputable = lengthComputable;
                    _this.total = total;
                    _this.loaded = loaded;
                    return _this;
                }
                return ProgressEvent;
            }(_this2.runtime.Event));
        };
        this.parseDocument = function(text) {
            var contentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var DOMParser, _ref, type;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    DOMParser = this.runtime.DOMParser;
                    _ref = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(';')) || [], 1), type = _ref[0];
                    return [
                        2,
                        new DOMParser().parseFromString(text, type || 'text/html')
                    ];
                });
            }).call(_this1);
        };
        this.makeFormData = function(data) {
            var FormData = _this.runtime.FormData;
            var formData = new FormData();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    var list = typeof value !== 'string' && (0, $8uLkp$webutility.likeArray)(value) ? value : [
                        value
                    ];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Array.from(list)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var item = _step1.value;
                            if (item != null) {
                                if ((typeof item === "undefined" ? "undefined" : (0, $8uLkp$swchelperscjs_type_ofcjs._)(item)) === 'object') formData.append(key, item, item.name);
                                else formData.append(key, item);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return formData;
        };
        this.serializeNode = function(root) {
            var _this_runtime = _this.runtime, URLSearchParams = _this_runtime.URLSearchParams, FormData = _this_runtime.FormData, Document = _this_runtime.Document, HTMLElement = _this_runtime.HTMLElement, SVGElement = _this_runtime.SVGElement;
            var contentType;
            if (!(root instanceof HTMLFormElement)) return {
                contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
                data: (0, $8uLkp$webutility.stringifyDOM)(root)
            };
            if (root.querySelector('input[type="file"][name]')) return {
                contentType: 'multipart/form-data',
                data: new FormData(root)
            };
            var data = (0, $8uLkp$webutility.formToJSON)(root);
            switch(contentType = root.enctype){
                case 'text/plain':
                    return {
                        contentType: contentType,
                        data: Object.entries(data).map(function(param) {
                            var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 2), name = _param[0], value = _param[1];
                            return "".concat(name, "=").concat(value);
                        }).join('\n')
                    };
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                default:
                    return {
                        contentType: 'application/json',
                        data: JSON.stringify(data)
                    };
            }
        };
        this.serialize = function(data, contentType) {
            var _this_runtime = _this.runtime, Node = _this_runtime.Node, URLSearchParams = _this_runtime.URLSearchParams, FormData = _this_runtime.FormData, Blob = _this_runtime.Blob, _$ReadableStream = _this_runtime.ReadableStream;
            var _ref = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(';')) || [], 1), type = _ref[0];
            switch(type){
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                case 'multipart/form-data':
                    return {
                        data: _this.makeFormData(data)
                    };
                case 'application/json':
                    return {
                        contentType: contentType,
                        data: JSON.stringify(data)
                    };
                case 'text/html':
                case 'application/xml':
                case 'image/svg':
                    return {
                        contentType: contentType,
                        data: (0, $8uLkp$webutility.stringifyDOM)(data)
                    };
            }
            if (type) return {
                data: data,
                contentType: contentType
            };
            try {
                if (data instanceof URLSearchParams) return {
                    contentType: 'application/x-www-form-urlencoded',
                    data: data
                };
            } catch (e) {}
            try {
                if (data instanceof FormData) return {
                    data: data
                };
            } catch (e) {}
            try {
                if (data instanceof Node) return _this.serializeNode(data);
            } catch (e) {}
            try {
                if ((0, $8uLkp$webutility.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof _$ReadableStream) return {
                    contentType: 'application/octet-stream',
                    data: data
                };
            } catch (e) {}
            try {
                return {
                    contentType: 'application/json',
                    data: JSON.stringify(data)
                };
            } catch (e) {}
            throw new Error('Unserialized Object needs a specific Content-Type');
        };
        this.readBytes = function(stream) {
            var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var Blob, chunks;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            Blob = this.runtime.Blob;
                            return [
                                4,
                                Array.fromAsync(this.takeBytes(stream, limit))
                            ];
                        case 1:
                            chunks = _state.sent();
                            return [
                                2,
                                new Blob(chunks).arrayBuffer()
                            ];
                    }
                });
            }).call(_this1);
        };
        this.makeStream = function() {
            for(var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++){
                chunks[_key] = arguments[_key];
            }
            var Blob = _this1.runtime.Blob;
            return new Blob(chunks).stream();
        };
        this.streamFromProgress = function(target) {
            return (0, $8uLkp$webutility.createAsyncIterator)(function(param) {
                var next = param.next, complete = param.complete, error = param.error;
                var handleProgress = function(param) {
                    var loaded = param.loaded, total = param.total;
                    next({
                        loaded: loaded,
                        total: total
                    });
                    if (loaded >= total) complete();
                };
                target.addEventListener('progress', handleProgress);
                target.addEventListener('error', error);
                return function() {
                    target.removeEventListener('progress', handleProgress);
                    target.removeEventListener('error', error);
                };
            });
        };
        this.emitStreamProgress = function(stream, total, eventTarget) {
            var ProgressEvent = _this.runtime.ProgressEvent;
            return function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_wrap_async_generatorcjs._)(function() {
                    var loaded, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, event, err;
                    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                loaded = 0;
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    13
                                ]);
                                _iterator = (0, $8uLkp$swchelperscjs_async_iteratorcjs._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    6
                                ];
                                _value = _step.value;
                                chunk = _value;
                                return [
                                    4,
                                    chunk
                                ];
                            case 4:
                                _state.sent();
                                loaded += chunk.byteLength;
                                event = new ProgressEvent('progress', {
                                    lengthComputable: isNaN(total),
                                    loaded: loaded,
                                    total: total
                                });
                                eventTarget.dispatchEvent(event);
                                _state.label = 5;
                            case 5:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(_iterator.return())
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }();
        };
        this.readAs = function(file, method, encoding) {
            var FileReader = _this.runtime.FileReader;
            var reader = new FileReader();
            var result = new Promise(function(resolve, reject) {
                reader.onerror = reject;
                reader.onload = function() {
                    return resolve(reader.result);
                };
                reader[FileMethod[method]](file, encoding);
            });
            return {
                progress: _this.streamFromProgress(reader),
                result: result
            };
        };
        this./**
     * @param  raw - Binary data
     *
     * @return  Base64 encoded data
     */ encodeBase64 = function(raw) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var Blob, text, text1;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            Blob = this.runtime.Blob;
                            if (!(raw instanceof Blob)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.readAs(raw, 'dataURL').result
                            ];
                        case 1:
                            text = _state.sent();
                            return [
                                2,
                                (DataURI.exec(text) || '')[4]
                            ];
                        case 2:
                            text1 = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, function(_, p1) {
                                return String.fromCharCode(+('0x' + p1));
                            });
                            return [
                                2,
                                btoa(text1)
                            ];
                    }
                });
            }).call(_this);
        };
        if (runtime.Event) this.runtime.ProgressEvent = this.polyfillProgressEvent();
    }
    (0, $8uLkp$swchelperscjs_create_classcjs._)(DataToolkit, [
        {
            key: "takeBytes",
            value: function takeBytes(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_wrap_async_generatorcjs._)(function(stream) {
                    var limit, total, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, remaining, err;
                    var _arguments = arguments;
                    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                limit = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : Infinity;
                                total = 0;
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    9,
                                    10,
                                    15
                                ]);
                                _iterator = (0, $8uLkp$swchelperscjs_async_iteratorcjs._)(stream);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(_iterator.next())
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    8
                                ];
                                _value = _step.value;
                                chunk = _value;
                                remaining = limit - total;
                                if (!(chunk.byteLength > remaining)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    chunk.slice(0, remaining)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                return [
                                    4,
                                    new Uint8Array(chunk)
                                ];
                            case 6:
                                _state.sent();
                                total += chunk.byteLength;
                                if (total >= limit) return [
                                    3,
                                    8
                                ];
                                _state.label = 7;
                            case 7:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 8:
                                return [
                                    3,
                                    15
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    15
                                ];
                            case 10:
                                _state.trys.push([
                                    10,
                                    ,
                                    13,
                                    14
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    12
                                ];
                                return [
                                    4,
                                    (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(_iterator.return())
                                ];
                            case 11:
                                _state.sent();
                                _state.label = 12;
                            case 12:
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    7
                                ];
                            case 15:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return DataToolkit;
}();
var _ref = new DataToolkit();
var polyfillProgressEvent = _ref.polyfillProgressEvent, parseDocument = _ref.parseDocument, makeFormData = _ref.makeFormData, serializeNode = _ref.serializeNode, serialize = _ref.serialize, takeBytes = _ref.takeBytes, readBytes = _ref.readBytes, makeStream = _ref.makeStream, streamFromProgress = _ref.streamFromProgress, emitStreamProgress = _ref.emitStreamProgress, readAs = _ref.readAs, encodeBase64 = _ref.encodeBase64;

});

var $cc2cf063163d66d5$exports = {};

$parcel$export($cc2cf063163d66d5$exports, "Stack", function () { return $cc2cf063163d66d5$export$694e0d28c7ffc90c; });


var $cc2cf063163d66d5$var$push = Array.prototype.push;
var $cc2cf063163d66d5$export$694e0d28c7ffc90c = /*#__PURE__*/ function() {
    "use strict";
    function Stack() {
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, Stack);
        this.length = 0;
    }
    (0, $8uLkp$swchelperscjs_create_classcjs._)(Stack, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                $cc2cf063163d66d5$var$push.apply(this, middlewares);
                return this;
            }
        },
        {
            key: "execute",
            value: function execute(context) {
                var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var middleware = this[depth];
                if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
            }
        },
        {
            key: "mount",
            value: function mount(condition, stack) {
                return this.use(function(context, next) {
                    return condition(context) ? stack.execute(context) : next();
                });
            }
        }
    ]);
    return Stack;
}();


var $3a954e4575472d21$exports = {};

$parcel$export($3a954e4575472d21$exports, "BodyRequestMethods", function () { return $3a954e4575472d21$export$4125cfe7e08e2040; });
$parcel$export($3a954e4575472d21$exports, "HTTPError", function () { return $3a954e4575472d21$export$aa9d629c530f62a7; });
$parcel$export($3a954e4575472d21$exports, "headerParser", function () { return $3a954e4575472d21$export$b725a69477e4d33f; });
$parcel$export($3a954e4575472d21$exports, "parseHeaders", function () { return $3a954e4575472d21$export$eea2c1c5e1a37e50; });
$parcel$export($3a954e4575472d21$exports, "parseBody", function () { return $3a954e4575472d21$export$3b629cd0ff482602; });
$parcel$export($3a954e4575472d21$exports, "FILE_TYPE_MAGIC_NUMBER_SIZE", function () { return $3a954e4575472d21$export$153cac11fce574d; });
$parcel$export($3a954e4575472d21$exports, "defaultHTTPRuntime", function () { return $3a954e4575472d21$export$80e06a8ed038dcf8; });
$parcel$export($3a954e4575472d21$exports, "HTTPToolkit", function () { return $3a954e4575472d21$export$7370b3fc922cf1e6; });
$parcel$export($3a954e4575472d21$exports, "requestXHR", function () { return $3a954e4575472d21$export$4f2a8c8c11a6373a; });
$parcel$export($3a954e4575472d21$exports, "requestFetch", function () { return $3a954e4575472d21$export$bda27a3e49197b9; });
$parcel$export($3a954e4575472d21$exports, "parseResponse", function () { return $3a954e4575472d21$export$ba14d9a5a581e827; });
$parcel$export($3a954e4575472d21$exports, "parseFetchBody", function () { return $3a954e4575472d21$export$b7b86d31099674dc; });
$parcel$export($3a954e4575472d21$exports, "rawRequest", function () { return $3a954e4575472d21$export$3052fa16c23a17ef; });
$parcel$export($3a954e4575472d21$exports, "requestHead", function () { return $3a954e4575472d21$export$199f266664335871; });
$parcel$export($3a954e4575472d21$exports, "request", function () { return $3a954e4575472d21$export$b5fe3f66a567bec0; });















var $fxgA4 = parcelRequire("fxgA4");
var $3a954e4575472d21$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
var $3a954e4575472d21$export$aa9d629c530f62a7 = /*#__PURE__*/ function(URIError1) {
    "use strict";
    (0, $8uLkp$swchelperscjs_inheritscjs._)(HTTPError, URIError1);
    function HTTPError(message, request, response) {
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, HTTPError);
        var _this;
        _this = (0, $8uLkp$swchelperscjs_call_supercjs._)(this, HTTPError, [
            message
        ]), _this.request = request, _this.response = response;
        return _this;
    }
    return HTTPError;
}((0, $8uLkp$swchelperscjs_wrap_native_supercjs._)(URIError));
var $3a954e4575472d21$export$b725a69477e4d33f = {
    Link: function(value) {
        return Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), function(param) {
            var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 4), _ = _param[0], URI = _param[1], rel = _param[2], title = _param[3];
            return [
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ];
        }));
    }
};
var $3a954e4575472d21$export$eea2c1c5e1a37e50 = function(raw) {
    return Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), function(param) {
        var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 3), _ = _param[0], key = _param[1], value = _param[2];
        var _headerParser_key;
        key = key.replace(/(^[a-z]|-[a-z])/g, function(char) {
            return char.toUpperCase();
        });
        var _headerParser_key1;
        return [
            key,
            (_headerParser_key1 = (_headerParser_key = $3a954e4575472d21$export$b725a69477e4d33f[key]) === null || _headerParser_key === void 0 ? void 0 : _headerParser_key.call($3a954e4575472d21$export$b725a69477e4d33f, value)) !== null && _headerParser_key1 !== void 0 ? _headerParser_key1 : value
        ];
    }));
};
function $3a954e4575472d21$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $8uLkp$webutility.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return this.parseDocument(raw, contentType);
    } catch (e) {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
var $3a954e4575472d21$export$153cac11fce574d = 4100;
var $3a954e4575472d21$export$80e06a8ed038dcf8 = (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, (0, $fxgA4.defaultDataRuntime)), {
    EventTarget: globalThis.EventTarget,
    XMLHttpRequest: globalThis.XMLHttpRequest,
    Headers: globalThis.Headers,
    fetch: globalThis.fetch
});
var $3a954e4575472d21$export$7370b3fc922cf1e6 = /*#__PURE__*/ function(DataToolkit) {
    "use strict";
    (0, $8uLkp$swchelperscjs_inheritscjs._)(HTTPToolkit, DataToolkit);
    function HTTPToolkit() {
        var runtime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $3a954e4575472d21$export$80e06a8ed038dcf8;
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, HTTPToolkit);
        var _this;
        var _this1;
        _this = (0, $8uLkp$swchelperscjs_call_supercjs._)(this, HTTPToolkit, [
            runtime
        ]), _this1 = _this, _this1.runtime = runtime, _this1.requestXHR = function(_param) {
            var _param_method = _param.method, method = _param_method === void 0 ? 'GET' : _param_method, path = _param.path, _param_headers = _param.headers, headers = _param_headers === void 0 ? {} : _param_headers, body = _param.body, signal = _param.signal, rest = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param, [
                "method",
                "path",
                "headers",
                "body",
                "signal"
            ]);
            var _this_runtime = _this1.runtime, XMLHttpRequest = _this_runtime.XMLHttpRequest, Headers = _this_runtime.Headers, Blob = _this_runtime.Blob, ReadableStream = _this_runtime.ReadableStream;
            var request = new XMLHttpRequest();
            var header = new Headers(headers);
            var bodyPromise = body instanceof ReadableStream ? Array.fromAsync(body).then(function(parts) {
                return new Blob(parts);
            }) : Promise.resolve(body);
            var abort = function() {
                return request.abort();
            };
            signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abort);
            var response = new Promise(function(resolve, reject) {
                var _header_get;
                request.onreadystatechange = function() {
                    var readyState = request.readyState, status = request.status, statusText = request.statusText, responseType = request.responseType;
                    if (readyState !== 4 || !status && !(signal === null || signal === void 0 ? void 0 : signal.aborted)) return;
                    resolve({
                        status: status,
                        statusText: statusText,
                        headers: $3a954e4575472d21$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                        body: responseType && responseType !== 'text' ? request.response : request.responseText
                    });
                };
                request.onerror = request.ontimeout = reject;
                var _ref = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(((_header_get = header.get('Accept')) === null || _header_get === void 0 ? void 0 : _header_get.split(',')) || [
                    rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
                ], 1), MIMEType = _ref[0];
                if (MIMEType) request.overrideMimeType(MIMEType);
                request.open(method, path + '');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        request.setRequestHeader(key, value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                Object.assign(request, rest);
                bodyPromise.then(function(body) {
                    return request.send(body);
                });
            }).then(function(_param) {
                var body = _param.body, meta = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param, [
                    "body"
                ]);
                signal === null || signal === void 0 ? void 0 : signal.throwIfAborted();
                var contentType = request.getResponseHeader('Content-Type') || '';
                if (typeof body === 'string' && !contentType.includes('text')) body = $3a954e4575472d21$export$3b629cd0ff482602(body, contentType);
                return (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, meta), {
                    body: body
                });
            });
            response.finally(function() {
                return signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abort);
            });
            return {
                response: response,
                upload: _this1.streamFromProgress(request.upload),
                download: _this1.streamFromProgress(request)
            };
        }, _this1.requestFetch = function(param) {
            var path = param.path, method = param.method, headers = param.headers, withCredentials = param.withCredentials, body = param.body, signal = param.signal, timeout = param.timeout, responseType = param.responseType;
            var _this_runtime = _this1.runtime, EventTarget = _this_runtime.EventTarget, Headers = _this_runtime.Headers, ReadableStream = _this_runtime.ReadableStream, fetch = _this_runtime.fetch;
            var signals = [
                signal,
                timeout && AbortSignal.timeout(timeout)
            ].filter(Boolean);
            headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
            headers = responseType === 'text' ? (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, headers), {
                Accept: 'text/plain'
            }) : responseType === 'json' ? (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, headers), {
                Accept: 'application/json'
            }) : responseType === 'document' ? (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, headers), {
                Accept: 'text/html, application/xhtml+xml, application/xml'
            }) : responseType === 'arraybuffer' || responseType === 'blob' ? (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, headers), {
                Accept: 'application/octet-stream'
            }) : headers;
            var isStream = body instanceof ReadableStream;
            var upload;
            if (isStream) {
                var uploadProgress = new EventTarget();
                body = ReadableStream.from(_this1.emitStreamProgress(body, +headers['Content-Length'], uploadProgress));
                upload = _this1.streamFromProgress(uploadProgress);
            }
            var downloadProgress = new EventTarget();
            var response = fetch(path + '', {
                method: method,
                headers: headers,
                credentials: withCredentials ? 'include' : 'omit',
                body: body,
                signal: signals[0] && AbortSignal.any(signals),
                // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
                duplex: isStream ? 'half' : undefined
            }).then(function(response) {
                return _this1.parseResponse(response, responseType, downloadProgress);
            });
            var download = _this1.streamFromProgress(downloadProgress);
            return {
                response: response,
                upload: upload,
                download: download
            };
        }, _this1.parseResponse = function(param, responseType, downloadProgress) {
            var status = param.status, statusText = param.statusText, headers = param.headers, body = param.body;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var ReadableStream, contentType, header, stream, rBody;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ReadableStream = _this1.runtime.ReadableStream;
                            contentType = headers.get('Content-Type') || '';
                            header = $3a954e4575472d21$export$eea2c1c5e1a37e50((0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(headers).map(function(param) {
                                var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 2), key = _param[0], value = _param[1];
                                return "".concat(key, ": ").concat(value);
                            }).join('\n'));
                            if (status === 204 || !body) return [
                                2,
                                {
                                    status: status,
                                    statusText: statusText,
                                    headers: header,
                                    body: undefined
                                }
                            ];
                            stream = ReadableStream.from(_this1.emitStreamProgress(ReadableStream.from(body), +headers.get('Content-Length'), downloadProgress));
                            return [
                                4,
                                _this1.parseFetchBody(stream, contentType, responseType)
                            ];
                        case 1:
                            rBody = _state.sent();
                            return [
                                2,
                                {
                                    status: status,
                                    statusText: statusText,
                                    headers: header,
                                    body: rBody
                                }
                            ];
                    }
                });
            })();
        }, _this1.parseFetchBody = function(stream, contentType, responseType) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var Blob, blob, _, text;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            Blob = _this1.runtime.Blob;
                            _ = Blob.bind;
                            return [
                                4,
                                Array.fromAsync(stream)
                            ];
                        case 1:
                            blob = new (_.apply(Blob, [
                                void 0,
                                _state.sent(),
                                {
                                    type: contentType
                                }
                            ]));
                            if (responseType === 'blob') return [
                                2,
                                blob
                            ];
                            if (responseType === 'arraybuffer') return [
                                2,
                                blob.arrayBuffer()
                            ];
                            return [
                                4,
                                blob.text()
                            ];
                        case 2:
                            text = _state.sent();
                            if (responseType === 'text') return [
                                2,
                                text
                            ];
                            return [
                                2,
                                $3a954e4575472d21$export$3b629cd0ff482602(text, contentType)
                            ];
                    }
                });
            })();
        }, _this1.rawRequest = typeof _this1.runtime.XMLHttpRequest === 'function' ? _this1.requestXHR : _this1.requestFetch, _this1./**
     * Sends a `HEAD` request, falling back to simulation when the server does
     * not support `HEAD`. Tries, in order:
     * 1. A standard `HEAD` request via `fetch()`.
     * 2. A `Range` GET to retrieve the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes (magic-number file header).
     * 3. A plain `GET` that reads the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes then cancels the body stream.
     */ requestHead = function(param) {
            var path = param.path, headers = param.headers, withCredentials = param.withCredentials, timeout = param.timeout, signal = param.signal;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var _this_runtime, Headers, fetch, normalizedHeaders, signals, fetchOptions, toHeaders, response, e, response1, _tmp, e1, response2, body;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_runtime = _this1.runtime, Headers = _this_runtime.Headers, fetch = _this_runtime.fetch;
                            normalizedHeaders = !headers ? {} : headers instanceof Headers ? Object.fromEntries(headers) : Array.isArray(headers) ? Object.fromEntries(headers) : headers;
                            signals = [
                                signal,
                                timeout && AbortSignal.timeout(timeout)
                            ].filter(Boolean);
                            fetchOptions = {
                                credentials: withCredentials ? 'include' : 'omit',
                                signal: signals[1] ? AbortSignal.any(signals) : signals[0]
                            };
                            toHeaders = function(raw) {
                                return $3a954e4575472d21$export$eea2c1c5e1a37e50((0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(raw).map(function(param) {
                                    var _param = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(param, 2), k = _param[0], v = _param[1];
                                    return "".concat(k, ": ").concat(v);
                                }).join('\n'));
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetch(path + '', (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                                    method: 'HEAD'
                                }, fetchOptions), {
                                    headers: normalizedHeaders
                                }))
                            ];
                        case 2:
                            response = _state.sent();
                            if (response.ok) return [
                                2,
                                {
                                    headers: toHeaders(response.headers)
                                }
                            ];
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            _state.trys.push([
                                4,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                fetch(path + '', (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, fetchOptions), {
                                    headers: (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, normalizedHeaders), {
                                        Range: "bytes=0-".concat($3a954e4575472d21$export$153cac11fce574d - 1)
                                    })
                                }))
                            ];
                        case 5:
                            response1 = _state.sent();
                            if (!response1.ok) throw new Error("".concat(response1.status, " ").concat(response1.statusText));
                            _tmp = {
                                headers: toHeaders(response1.headers)
                            };
                            return [
                                4,
                                response1.arrayBuffer()
                            ];
                        case 6:
                            return [
                                2,
                                (_tmp.body = _state.sent(), _tmp)
                            ];
                        case 7:
                            e1 = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                4,
                                fetch(path, (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, fetchOptions), {
                                    headers: normalizedHeaders
                                }))
                            ];
                        case 9:
                            response2 = _state.sent();
                            return [
                                4,
                                _this1.readBytes((0, $8uLkp$webstreamspolyfill.ReadableStream).from(response2.body), $3a954e4575472d21$export$153cac11fce574d)
                            ];
                        case 10:
                            body = _state.sent();
                            return [
                                2,
                                {
                                    headers: toHeaders(response2.headers),
                                    body: body
                                }
                            ];
                    }
                });
            })();
        }, _this1./**
     * Sends a {@link Request}, with automatic HEAD-simulation fallback for
     * servers that do not support the `HEAD` method.
     */ request = function(option) {
            if (option.method !== 'HEAD') return _this1.rawRequest(option);
            var response = _this1.requestHead(option).then(function(param) {
                var headers = param.headers, body = param.body;
                return {
                    status: 204,
                    statusText: 'No Content',
                    headers: headers,
                    body: body
                };
            });
            return {
                response: response,
                download: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_wrap_async_generatorcjs._)(function() {
                        return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    })();
                }()
            };
        };
        return _this;
    }
    return HTTPToolkit;
}((0, $fxgA4.DataToolkit));
var $3a954e4575472d21$var$_ref = new $3a954e4575472d21$export$7370b3fc922cf1e6();
var $3a954e4575472d21$export$4f2a8c8c11a6373a = $3a954e4575472d21$var$_ref.requestXHR, $3a954e4575472d21$export$bda27a3e49197b9 = $3a954e4575472d21$var$_ref.requestFetch, $3a954e4575472d21$export$ba14d9a5a581e827 = $3a954e4575472d21$var$_ref.parseResponse, $3a954e4575472d21$export$b7b86d31099674dc = $3a954e4575472d21$var$_ref.parseFetchBody, $3a954e4575472d21$export$3052fa16c23a17ef = $3a954e4575472d21$var$_ref.rawRequest, $3a954e4575472d21$export$199f266664335871 = $3a954e4575472d21$var$_ref.requestHead, $3a954e4575472d21$export$b5fe3f66a567bec0 = $3a954e4575472d21$var$_ref.request;


var $534f61cf326f381e$exports = {};

$parcel$export($534f61cf326f381e$exports, "HTTPClient", function () { return $534f61cf326f381e$export$45cf759b359d3d24; });




















var $fxgA4 = parcelRequire("fxgA4");
var $534f61cf326f381e$var$_globalThis_document;
var $534f61cf326f381e$var$splice = Array.prototype.splice;
var $534f61cf326f381e$export$45cf759b359d3d24 = /*#__PURE__*/ function(Stack) {
    "use strict";
    (0, $8uLkp$swchelperscjs_inheritscjs._)(HTTPClient, Stack);
    function HTTPClient() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $8uLkp$swchelperscjs_class_call_checkcjs._)(this, HTTPClient);
        var _this;
        var _this1, _superprop_get_use = function() {
            return (0, $8uLkp$swchelperscjs_getcjs._)(((0, $8uLkp$swchelperscjs_assert_this_initializedcjs._)(_this), (0, $8uLkp$swchelperscjs_get_prototype_ofcjs._)(HTTPClient.prototype)), "use", _this);
        };
        var _param_baseURI = _param.baseURI, baseURI = _param_baseURI === void 0 ? ($534f61cf326f381e$var$_globalThis_document = globalThis.document) === null || $534f61cf326f381e$var$_globalThis_document === void 0 ? void 0 : $534f61cf326f381e$var$_globalThis_document.baseURI : _param_baseURI, _param_baseRequest = _param.baseRequest, baseRequest = _param_baseRequest === void 0 ? (0, $3a954e4575472d21$export$b5fe3f66a567bec0) : _param_baseRequest, options = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param, [
            "baseURI",
            "baseRequest"
        ]);
        _this = (0, $8uLkp$swchelperscjs_call_supercjs._)(this, HTTPClient), _this1 = _this, _this1.defaultWare = function(param, next) {
            var _$request = param.request, response = param.response;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var _request_method, method, _request_headers, headers, body, _serialize, contentType, data;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _request_method = _$request.method, method = _request_method === void 0 ? 'GET' : _request_method, _request_headers = _$request.headers, headers = _request_headers === void 0 ? {} : _request_headers, body = _$request.body;
                            if (method in (0, $3a954e4575472d21$export$4125cfe7e08e2040) && body && (typeof body === "undefined" ? "undefined" : (0, $8uLkp$swchelperscjs_type_ofcjs._)(body)) === 'object') {
                                _serialize = (0, $fxgA4.serialize)(body, headers['Content-Type']), contentType = _serialize.contentType, data = _serialize.data;
                                if (contentType) headers['Content-Type'] = contentType;
                                _$request.body = data;
                            }
                            return [
                                4,
                                next()
                            ];
                        case 1:
                            _state.sent();
                            if (response.status > 299) throw new (0, $3a954e4575472d21$export$aa9d629c530f62a7)(response.statusText, _$request, response);
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        _this1.baseURI = baseURI;
        _this1.baseRequest = baseRequest;
        _this1.options = options;
        _superprop_get_use().call(_this1, _this1.defaultWare);
        _superprop_get_use().call(_this1, function(param) {
            var data = param.request, response = param.response;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                var _, _tmp;
                return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            data.path = new URL(data.path, _this1.baseURI) + '';
                            _ = Object.assign;
                            _tmp = [
                                response
                            ];
                            return [
                                4,
                                _this1.baseRequest((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, options, data)).response
                            ];
                        case 1:
                            _.apply(Object, _tmp.concat([
                                _state.sent()
                            ]));
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        return _this;
    }
    (0, $8uLkp$swchelperscjs_create_classcjs._)(HTTPClient, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                var _splice;
                (_splice = $534f61cf326f381e$var$splice).call.apply(_splice, [
                    this,
                    -2,
                    0
                ].concat((0, $8uLkp$swchelperscjs_to_consumable_arraycjs._)(middlewares)));
                return this;
            }
        },
        {
            key: "request",
            value: function request(data) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                    var context;
                    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = {
                                    request: (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, data), {
                                        headers: (0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, data.headers)
                                    }),
                                    response: {}
                                };
                                return [
                                    4,
                                    this.execute(context)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    context.response
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "head",
            value: function head(path, headers, options) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_async_to_generatorcjs._)(function() {
                    var _ref, data;
                    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.request((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                                        method: 'HEAD',
                                        path: path,
                                        headers: headers
                                    }, options))
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.headers;
                                return [
                                    2,
                                    data
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get(path, headers, options) {
                return this.request((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                    method: 'GET',
                    path: path,
                    headers: headers
                }, options));
            }
        },
        {
            key: "post",
            value: function post(path, body, headers, options) {
                return this.request((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                    method: 'POST',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "put",
            value: function put(path, body, headers, options) {
                return this.request((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                    method: 'PUT',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "patch",
            value: function patch(path, body, headers, options) {
                return this.request((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                    method: 'PATCH',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "delete",
            value: function _delete(path, body, headers, options) {
                return this.request((0, $8uLkp$swchelperscjs_object_spreadcjs._)({
                    method: 'DELETE',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "download",
            value: function download(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $8uLkp$swchelperscjs_wrap_async_generatorcjs._)(function(path) {
                    var _param, headers, _param_chunkSize, chunkSize, tmp, _ref, tmp1, start, tmp2, end, options, _ref1, length, total, i, j, _ref2, status, body, loaded;
                    var _arguments = arguments;
                    return (0, $8uLkp$swchelperscjs_ts_generatorcjs._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _param = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                headers = _param.headers, _param_chunkSize = _param.chunkSize, chunkSize = _param_chunkSize === void 0 ? Math.pow(1024, 2) : _param_chunkSize, tmp = _param.range, _ref = (0, $8uLkp$swchelperscjs_sliced_to_arraycjs._)(tmp === void 0 ? [] : tmp, 2), tmp1 = _ref[0], start = tmp1 === void 0 ? 0 : tmp1, tmp2 = _ref[1], end = tmp2 === void 0 ? Infinity : tmp2, options = (0, $8uLkp$swchelperscjs_object_without_propertiescjs._)(_param, [
                                    "headers",
                                    "chunkSize",
                                    "range"
                                ]);
                                return [
                                    4,
                                    (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(this.head(path, headers, options))
                                ];
                            case 1:
                                _ref1 = _state.sent(), length = _ref1['Content-Length'];
                                total = +length;
                                if (end === Infinity) end = total;
                                i = start, j = i - 1 + chunkSize;
                                _state.label = 2;
                            case 2:
                                if (!(i < end)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    (0, $8uLkp$swchelperscjs_await_async_generatorcjs._)(this.get(path, (0, $8uLkp$swchelperscjs_object_spread_propscjs._)((0, $8uLkp$swchelperscjs_object_spreadcjs._)({}, headers), {
                                        Range: "bytes=".concat(i, "-").concat(j)
                                    }), options))
                                ];
                            case 3:
                                _ref2 = _state.sent(), status = _ref2.status, body = _ref2.body;
                                if (!(status !== 206)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: total,
                                        percent: 100,
                                        buffer: body
                                    }
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                loaded = i + body.byteLength;
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: loaded,
                                        percent: +(loaded / total * 100).toFixed(2),
                                        buffer: body
                                    }
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                i = j + 1, j += chunkSize;
                                return [
                                    3,
                                    2
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return HTTPClient;
}((0, $cc2cf063163d66d5$export$694e0d28c7ffc90c));



var $fxgA4 = parcelRequire("fxgA4");
$parcel$exportWildcard(module.exports, $cc2cf063163d66d5$exports);
$parcel$exportWildcard(module.exports, $3a954e4575472d21$exports);
$parcel$exportWildcard(module.exports, $534f61cf326f381e$exports);
$parcel$exportWildcard(module.exports, $fxgA4);


//# sourceMappingURL=index.js.map
